import {
  ExternalImageHotspotProduct,
  ImageHotspotProduct
} from 'components/discovery/widgets/image-hotspot/typing/product-types.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const IMAGE_HOTSPOT_API = Symbol('IMAGE_HOTSPOT_API')

export class ImageHotspotGetRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }
  controller: AbortController = new AbortController()

  constructor(productEndpoint: string) {
    this.endpointUrl = new URL(productEndpoint, window.location.href)
  }
}

@registerDependency(REAL, IMAGE_HOTSPOT_API)
export class ImageHotspotAPI {
  requests: ImageHotspotGetRequest[] = []

  getProduct = async (request: ImageHotspotGetRequest): Promise<ExternalImageHotspotProduct> => {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers
    })

    return await response.json()
  }
}

@registerDependency(FAKE, IMAGE_HOTSPOT_API)
export class FakeImageHotspotAPI {
  product: ImageHotspotProduct | null = null
  requests: ImageHotspotGetRequest[] = []

  getProduct(request: ImageHotspotGetRequest) {
    this.requests.push(request)
    return Promise.resolve(this.product)
  }
}
